const pageKey = {
  newCarPurchase: 'NCP',
  productKnowledge: 'PK',
  newsTips: 'NT',
  servicePackage: 'package',
  serviceCoupon: 'coupon',
  usedCarPurchase: 'USEDCAR',
};

export default pageKey;
